import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/forms/get-outcome-form-by-name/return_to_owner';

  return API({ endpoint });
}
